<template>
  <q-dialog v-model="add">
    <q-card style="width: 320px">
      <q-form @submit="onSubmit">
        <div class="q-pa-md">
          <div class="row">
            <div class="col-12">
              <q-input
                lazy-rules
                outlined
                label="Custom Tag Name*"
                v-model="name"
                :rules="[val => (val !== null && val !== '') || 'Please type manual name']"
              ></q-input>
            </div>
            <div class="col-12" style="margin-top:5px">
              <q-input
                outlined
                label="Custom Tag Color*"
                v-model="color"
                :rules="[isValidColor]"
                class="my-input"
              >
                <template v-slot:append>
                  <q-icon name="fas fa-paint-brush" size="14px" class="cursor-pointer">
                    <q-popup-proxy transition-show="scale" transition-hide="scale">
                      <q-color no-header no-footer v-model="color" />
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </div>
            <div style="display: flex; justify-content: flex-end" class="col-12">
              <q-btn label="Close" @click="add = false" color="negative" style="margin-right: 5px"></q-btn>
              <q-btn :loading="loading" :disable="loading" label="Save" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook />
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import isValidColor from '../helper/colorValidation'
import axios from '../axios'
export default {
  data() {
    return {
      loading: false,
      name: '',
      color: ''
    }
  },
  methods: {
    isValidColor,
    async onSubmit() {
      // server fire
      try {
        this.loading = true
        const body = {
          name: this.name,
          color: this.color
        }
        const { data } = await axios.put('vehicle-tags', body)
        this.loading = false
        this.$store.commit('tag/SET_ADD_TAG', data.data)
        this.name = ''
        this.add = false
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    add: {
      get() {
        return this.$store.state.tag.add
      },
      set(val) {
        this.$store.commit('tag/SET_ADD', val)
      }
    }
  }
}
</script>
